<ion-header>
    <ion-toolbar class="header-color">
        <ion-buttons slot="start">
            <ion-back-button></ion-back-button>
         </ion-buttons>
      <ion-title class="toolbar-title">Our Story</ion-title>
    </ion-toolbar>
    <app-promoga-alert></app-promoga-alert>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <div class="padding story-section">
          <div class="text-center">
            <div class="padding-top-extra" id="howitworks">
            <h4>
              <b class="text-primary">
                Promoga
              </b> 
              <br>
              is a self-service platform that makes it easy to join or teach local fitness and wellness activities, connecting people who share a passion for wellness. Instructors and students in the Promoga community create friendships and nurture happiness while pursuing healthy bodies and minds.
            </h4>
            <br>
            <h4>
              <b class="text-primary">
                Promoga's mission
              </b>  
              <br>
              is to create a social community that is passionate about wellness by empowering people to participate in local, independent fitness and wellness activities. Promoga believes that when people connect easily through fitness and wellness activities, they create memorable friendships and shared experiences, and foster a peaceful, prosperous world.
            </h4>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
